import { APP_NAVIGATION } from './app-navigation.config';

export interface RouteCatalogEntry {
    moduleLabel?: string;
    sectionLabel?: string;
    pageLabel?: string;
    moduleIdentifier: string;
    sectionIdentifier: string;
    pageIdentifier: string;
    routerLink: string;
}

/** Rutas del shell que no viven en APP_NAVIGATION (no salen del menú de Identity). */
export const SHELL_ROUTES = {
    dashboard: '/dashboard',
    perfil: '/perfil',
} as const;

/** Metadata de página (título/icono) de las rutas del shell, para el header. */
export const SHELL_PAGE_META: Readonly<Record<string, { title: string; icon: string }>> = {
    [SHELL_ROUTES.dashboard]: { title: 'Dashboard', icon: 'pi pi-th-large' },
    [SHELL_ROUTES.perfil]: { title: 'Perfil', icon: 'pi pi-user' },
};

/** Id sintético del enlace directo «Dashboard» del menú (no choca con ids de Identity). */
export const HOME_MENU_ID = 9980;

/** Ids sintéticos del grupo Administración del menú (no chocan con ids de Identity). */
export const ADMIN_MENU_IDS = {
    group: 9990,
    section: 9991,
    usuarios: 9992,
    paginas: 9993,
    roles: 9994,
} as const;

export const ADMIN_MODULE = 'administracion';
export const ADMIN_SECTION = 'sistema';

const ADMIN_ROUTE_CATALOG: RouteCatalogEntry[] = [
    {
        moduleLabel: 'Administración',
        sectionLabel: 'Sistema',
        pageLabel: 'Usuarios',
        moduleIdentifier: ADMIN_MODULE,
        sectionIdentifier: ADMIN_SECTION,
        pageIdentifier: 'usuarios',
        routerLink: '/admin/usuarios',
    },
    {
        moduleLabel: 'Administración',
        sectionLabel: 'Sistema',
        pageLabel: 'Páginas',
        moduleIdentifier: ADMIN_MODULE,
        sectionIdentifier: ADMIN_SECTION,
        pageIdentifier: 'paginas',
        routerLink: '/admin/paginas',
    },
    {
        moduleLabel: 'Administración',
        sectionLabel: 'Sistema',
        pageLabel: 'Roles',
        moduleIdentifier: ADMIN_MODULE,
        sectionIdentifier: ADMIN_SECTION,
        pageIdentifier: 'roles',
        routerLink: '/admin/roles',
    },
];

export const ROUTE_CATALOG: RouteCatalogEntry[] = [
    ...APP_NAVIGATION.map((entry) => ({
        moduleLabel: entry.moduleLabel,
        sectionLabel: entry.sectionLabel,
        pageLabel: entry.pageLabel,
        moduleIdentifier: entry.moduleIdentifier,
        sectionIdentifier: entry.sectionIdentifier,
        pageIdentifier: entry.pageIdentifier,
        routerLink: entry.routerLink,
    })),
    ...ADMIN_ROUTE_CATALOG,
];
